<template>
  <div class="page-header">
    <h1 class="page-title">Assinatura Eletrônica de Documentos</h1>
    <assinaturaEletronica />
  </div>
</template>


<script>
import assinaturaEletronica from "@/components/assinaturaEletronica/index";

export default {
  components: { assinaturaEletronica },
};
</script>

<style scoped>
.page-title {
  text-align: center;
  padding: 10px 0;
}
</style>